module.exports = __webpack_public_path__ + "img/scene_7.1a5125d7.jpg";